import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import { useQuizContext } from "./QuizContext";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import "./SignupCommon.css";

const SignupPage4: React.FC = () => {
  const [gender, setGender] = useState<string>("");
  const [isPlanningBaby, setIsPlanningBaby] = useState<string>("");
  const { setAnswer } = useQuizContext();
  const [uuid, setUuid] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const step1Completed = localStorage.getItem("step-1-completed");
    if (step1Completed) {
      navigate("/getting-started/step-1",{ replace: true });
    }
  }, []);
  const handleGenderOptionClick = (option: string) => {
    setGender(option);
    if (option === "Male") {
      setIsPlanningBaby("");
    }
  };

  const handleBabyPlanningOptionClick = (option: string) => {
    setIsPlanningBaby(option);
  };

  useEffect(() => {
    const savedGender = localStorage.getItem("gender");
    const savedIsPlanningBaby = localStorage.getItem("isPlanningBaby");

    if (savedGender) {
      const parsedGender = JSON.parse(savedGender);
      setGender(parsedGender.value);
    }

    if (savedIsPlanningBaby) {
      const parsedIsPlanningBaby = JSON.parse(savedIsPlanningBaby);
      setIsPlanningBaby(parsedIsPlanningBaby.value);
    }
  }, []);

  useEffect(() => {
    const storedValue = localStorage.getItem("isTakingGlp");
    if (storedValue) {
      try {
        const parsedValue = JSON.parse(storedValue);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    } else {
    }
  }, []);
  const handleNext = () => {
    if (gender) {
      localStorage.setItem(
        "gender",
        JSON.stringify({ key: "gender", value: gender, id: 18026054 })
      );
      setAnswer("gender", gender, "18026054");
    }
    if (isPlanningBaby) {
      localStorage.setItem(
        "isPlanningBaby",
        JSON.stringify({
          key: "isPlanningBaby",
          value: isPlanningBaby,
          id: 18026056,
        })
      );
      setAnswer("isPlanningBaby", "18026056", isPlanningBaby);
    }
    localStorage.setItem("step-1-completed", "true");
  };

  const genderOptions = ["Male", "Female"];
  const optionsForBabyPlanning = [
    "None of the Following",
    "Currently or possibly pregnant, or actively trying to become pregnant",
    "Breastfeeding or bottle feeding with breastmilk",
  ];

  const styles = {
    optionsStacked: {
      display: "flex",
      flexDirection: "column" as "column",
      gap: "15px",
      marginBottom: "20px",
      width: "100%",
      marginTop: "41px",
    },
    optionLabel: {
      fontSize: "18px",
      padding: "15px",
      cursor: "pointer",
      border: "1px solid #96C6DA",
      borderRadius: "10px",
      transition: "background-color 0.3s ease",
      width: "100%",
      textAlign: "center" as "center",
      backgroundColor: "white",
    },
    optionLabelSelected: {
      backgroundColor: "#0C3972",
      color: "white",
    },
  };
  const nextPage =
    gender === "Male" ||
    (gender === "Female" && isPlanningBaby === "None of the Following")
      ? "/getting-started/step-2"
      : "/getting-started/invalid-age";
  const step = 1;
  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={18} step={step} />
        <div className="signup-content">
          <p className="signup-intro">What is your sex assigned at birth?</p>
          <div className="optionsLeftRight">
            {genderOptions.map((option) => (
              <label
                key={option}
                className={`optionLabel ${
                  gender === option ? "optionLabelSelected" : ""
                }`}
                onClick={() => handleGenderOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          {gender === "Female" && (
            <>
              <p className="signup-question" style={{ marginTop: "72px" }}>
                Are you currently or planning for any of the following?
              </p>
              <div style={styles.optionsStacked}>
                {optionsForBabyPlanning.map((option) => (
                  <label
                    key={option}
                    onClick={() => handleBabyPlanningOptionClick(option)}
                    className={`otherOptionLabel ${
                      isPlanningBaby === option ? "optionLabelSelected" : ""
                    }`}
                  >
                    {option}
                  </label>
                ))}
              </div>
            </>
          )}
         <Link to={nextPage}>
            <button
              className="next-btn sticky-btn"
              onClick={handleNext}
              disabled={!gender || (gender === "Female" && !isPlanningBaby)}
            >
              Next →
            </button>
          </Link>
          {gender === "Female" && (
            <p className="femaleDisclaimer">
              Please note that we strongly recommend that you use an effective
              method of contraception during treatment with a GLP-1 medication
              and for at least 2 months thereafter. For those taking Zepbound or
              Mounjaro (tirzepatide), we recommend switching to a non-oral
              contraceptive method or adding a barrier method of contraception
              for four weeks after initiation and for four weeks after each dose
              escalation.
            </p>
          )}
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage4;
